import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { verifyKanbanItems } from 'b2b-apps/core/kanban';

export type UseVerifyKanbanItemsActionReturnType = typeof verifyKanbanItems;

export const useVerifyKanbanItemsAction = (): UseVerifyKanbanItemsActionReturnType => {
  const dispatch = useDispatch();

  return useMemo(() => bindActionCreators(verifyKanbanItems, dispatch),
    [dispatch]);
};
